import React from "react";

export const reducer = () => {
    return <div>reducer</div>;
};


